import * as Actions from '../../actions/venue';

const initialState = {
  data: [],
  selected: {
    data: null,
    isLoading: false,
    isLoaded: false,
    error: false,
  },
  isLoading: false,
  isLoaded: false,
  error: false,
};

const venues = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_VENUES:
    case Actions.GET_VENUES_WITHINRANGE:
    case Actions.GET_ALL_VENUES:
    case Actions.GET_VENUES_STATUSES: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: false,
      };
    }
    case Actions.GET_VENUES_SUCCESS:
      case Actions.GET_ALL_VENUES_SUCCESS:
    case Actions.GET_VENUES_WITHINRANGE_SUCCESS:
    case Actions.GET_VENUES_STATUSES_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        isLoaded: true,
        error: false,
      };
    }
    case Actions.GET_VENUES_ERROR:
    case Actions.GET_ALL_VENUES_ERROR:
    case Actions.GET_VENUES_WITHINRANGE_ERROR:
    case Actions.GET_VENUES_STATUSES_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.error,
      };
    }

    case Actions.ADD_VENUE: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: false,
      };
    }
    case Actions.ADD_VENUE_SUCCESS: {
      return {
        ...state,
        data: [...state.data, action.payload],
        isLoading: false,
        isLoaded: true,
        error: false,
      };
    }
    case Actions.ADD_VENUE_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.error,
      };
    }
    case Actions.SET_SELECTED_VENUE: {
      return {
        ...state,
        selected: {
          isLoading: true,
          isLoaded: false,
          error: false,
        },
      };
    }
    case Actions.SET_SELECTED_VENUE_SUCCESS: {
      return {
        ...state,
        selected: {
          data: action.payload,
          isLoading: false,
          isLoaded: true,
          error: false,
        },
      };
    }
    case Actions.SET_SELECTED_VENUE_ERROR: {
      return {
        ...state,
        selected: {
          data: {},
          isLoading: false,
          isLoaded: false,
          error: action.error,
        },
      };
    }
    case Actions.ADD_VENUE_LOG_SUCCESS:
    case Actions.DELETE_VENUE_LOG_SUCCESS:
      return {
        ...state,
        selected: {
          ...state.selected,
          data: {
            ...state.selected.data,
            logs: action.payload.logs,
          },
        },
      };
    case Actions.ADD_VENUE_LOG_ERROR:
    case Actions.DELETE_VENUE_LOG_ERROR:
      return {
        ...state,
        selected: {
          data: {},
          isLoading: false,
          isLoaded: false,
          error: action.error,
        },
      };

    case Actions.UPDATE_VENUE: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: false,
      };
    }
    case Actions.UPDATE_VENUE_SUCCESS: {
      if (state.data && state.data.docs) {
        let newData = state.data.docs;
        let venueIndex = newData.findIndex(
          (venue) => venue._id === action.payload._id
        );
        newData[venueIndex] = action.payload;

        return {
          ...state,
          data: {
            ...state.data,
            docs: newData,
          },
          isLoading: false,
          isLoaded: true,
          error: false,
        };
      } else
        return {
          ...state,
          isLoading: false,
          isLoaded: false,
          error: false,
        };
    }
    case Actions.UPDATE_VENUE_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.error,
      };
    }

    case Actions.BULKUPDATE_VENUES: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: false,
      };
    }
    case Actions.BULKUPDATE_VENUES_SUCCESS: {
      let newData = state.data.docs.map((venue) => {
        let venueIndex = action.payload.findIndex((uv) => uv._id === venue._id);
        return venueIndex > -1 ? action.payload[venueIndex] : venue;
      });

      return {
        ...state,
        data: { ...state.data, docs: newData },
        isLoading: false,
        isLoaded: true,
        error: false,
      };
    }
    case Actions.BULKUPDATE_VENUES_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.error,
      };
    }

    case Actions.DELETE_VENUE: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: false,
      };
    }

    case Actions.DELETE_VENUE_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          docs: state.data.docs.filter((v) => v.firebaseUid !== action.payload),
        },
        isLoading: false,
        isLoaded: true,
        error: false,
      };
    }
    case Actions.DELETE_VENUE_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.error,
      };
    }

    case Actions.CHANGE_VENUE_ALIAS: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: false,
      };
    }
    case Actions.CHANGE_VENUE_ALIAS_SUCCESS: {
      const newData = [...state.data.docs];
      let index = newData.findIndex((v) => v._id === action.payload._id);
      const item = newData[index];
      newData.splice(index, 1, { ...item, ...action.payload });

      return {
        ...state,
        data: {
          ...state.data,
          docs: newData,
        },
        isLoading: false,
        isLoaded: true,
        error: false,
      };
    }
    case Actions.CHANGE_VENUE_ALIAS_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.error,
      };
    }

    case Actions.CHANGE_VENUE_EMAIL: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: false,
      };
    }
    case Actions.CHANGE_VENUE_EMAIL_SUCCESS: {
      const newData = [...state.data.docs];

      for (let venue of action.payload) {
        let index = newData.findIndex((v) => v._id === venue._id);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...venue });
      }

      return {
        ...state,
        data: {
          ...state.data,
          docs: newData,
        },
        isLoading: false,
        isLoaded: true,
        error: false,
      };
    }
    case Actions.CHANGE_VENUE_EMAIL_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

export default venues;
